import React, { useEffect, useState } from "react";

const GlobalSearchBar = ({ value, onSearch, placeholder }) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  return (
    <div className="d-flex align-items-center">
      <div className="me-2 w-100">
        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          value={internalValue}
          onChange={(e) => setInternalValue(e.target.value)}
        />
      </div>
      <button
        className="btn btn-primary"
        onClick={() => onSearch(internalValue)}
      >
        <i className="fa fa-search"></i>
      </button>
    </div>
  );
};

export default GlobalSearchBar;
